import { graphql } from "@opensea/graphql"

export const ActivityRarityFragment = graphql(`
  fragment ActivityRarity on Item {
    rarity {
      category
      rank
    }
  }
`)
